<template>
    <div class="selector_chainlink">
        <v-btn @click="blockDialog()">Add next</v-btn>
    </div>
</template>

<script>
export default {
  name: 'Add',
  props: ['x', 'y'],
  data: () => ({}),
  methods: {
    blockDialog () {
      this.$emit('blockDialog', this.y, this.x)
    }
  },
  computed: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/selector/Add.vue